/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["hr[_ngcontent-%COMP%]{margin-left:0;margin-right:0}.info-icon[_ngcontent-%COMP%]{font-size:large;padding:0;color:#6495ed}  .info-tooltip{font-size:small;border:double;background-color:#6495ed}"];
export { styles as styles };
